// French for FlowMatrix.tsx. Keys already carried by `i18n/common.fr.ts` and `NetworkZone.fr.ts`
// (held by rule, estimated, held, proposed …) are not repeated here.
import { registerFr } from '../../i18n/index.js';

registerFr({
  'No provider names a payer under these filters, so there is no matrix to draw.':
    'Sous ces filtres, aucun prestataire ne nomme de financeur — il n’y a pas de matrice à dessiner.',
  'rev.': 'prod.',
  'pl.': 'pl.',
  'Provider': 'Prestataire',
  'the Σ of this provider’s mix — computed, carries no mark': 'la Σ du mix de ce prestataire — calculée, sans marque',
  'attributed': 'attribué',
  'people': 'personnes',
  'proposed, not held': 'proposé, non tenu',
  '{n} rows on this pair': '{n} lignes pour cette paire',
  'Σ of the {basis} mix, {year}': 'Σ du mix « {basis} », {year}',
  'providers naming it': 'prestataires qui le nomment',
}, 'FlowMatrix');
